import { EditorState, convertFromRaw } from 'draft-js';

const initialState = {
    entityMap: {
        '0': {
            type: 'colorBlock',
            mutability: 'IMMUTABLE',
            data: {},
        },
    },
    blocks: [
        {
            key: 'e23a8',
            text: '',
            type: 'unstyled',
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
        },
    ],
}

export default {
    editorState: {
        data: EditorState.createWithContent(convertFromRaw(initialState))
    },
    ignoreList: {
        words: ['UK', 'USA', 'IT']
    },
    user: {},
    auth: [],
    modalStates: {
      isLoginSectionOpen: false,
    }
  };
